// Screens
export const DESKTOP_1 = 1360;
export const DESKTOP_2 = 1024;
export const DESKTOP_3 = 1200;
export const TABLET_1 = 650;
export const TABLET_2 = 800;
export const TABLET_3 = 900;
export const MOBILE_1 = 390;
export const MOBILE_2 = 480;
export const MOBILE_3 = 540;
